import { makeStyles, TextField, Typography, Button, CircularProgress } from "@material-ui/core"
import { useState } from "react";
import { useHistory } from 'react-router-dom';
import { postRequest } from "../Helpers/RequestHelper";
var sha256 = require('js-sha256');

const LoginPage = () => {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);

    const history = useHistory();

    const useStyles = makeStyles((theme) => ({
        loginPage: {
            paddingTop: 20,
            width: '80%',
            margin: 'auto'
        },
        loginForm: {
            width: '100%',
            margin: '20px auto',
            position: 'relative'
        },
        buttonProgress: {
            color: 'white',
            position: 'absolute',
            top: '50%',
            left: '50%',
            marginTop: -12,
            marginLeft: -12,
        },
        root: {
            '&$disabled': {
              backgroundColor: theme.palette.primary.light,
              color: 'white'
            },
          },
          disabled: {}
    }));

    const loginButtonPressed = (e) => {
        e.preventDefault();
        setLoading(true);
        
        var hashedPass = sha256.hmac('Gbdsk64H2k', password);
        var authObj = {
            fieldData: {
                FirstName: "Logging in to portal"
            },
            script: "Authenticate",
            "script.param": JSON.stringify({ username: email, password: hashedPass })
        };

        postRequest(authObj)
            .then(function (result) {
                if (!result.code) {
                    setError("Something went wrong when trying to log in");
                    setLoading(false);
                    return;
                }

                if (result.code === 200) {
                    localStorage.setItem("token", result.token);
                    if (result.forceChange === 1) {
                        setLoading(false);
                        return;
                    }
                    history.replace('/documents');
                    setLoading(false);
                    return;
                }

                setError(result.message);
                setLoading(false);

            })
            .catch(function (error) {
                setError(error.message);
                localStorage.setItem("token", "");
                setLoading(false);
            });

    };

    const forgotPasswordPressed = () => {
        history.push('/forgotpassword');
    };

    const classes = useStyles();

    return (
        <div className={classes.loginPage}>
            <form onSubmit={loginButtonPressed}>
                <div className={classes.loginForm}>
                    <TextField style={{ width: '100%' }} variant='outlined' id='email' label='Email address' value={email} onChange={(e) => setEmail(e.currentTarget.value)} />
                </div>
                <div className={classes.loginForm}>
                    <TextField style={{ width: '100%' }} variant='outlined' id='password' label='Password' value={password} type='password' onChange={(e) => setPassword(e.currentTarget.value)} />
                </div>
                <div className={classes.loginForm}>
                    {error !== "" && <Typography style={{ color: 'red' }}>{error}</Typography>}
                </div>
                <div className={classes.loginForm}>
                    <Button type="submit" style={{ width: '100%', height: 60 }} variant="contained" color="primary" disabled={loading} classes={{ disabled: classes.disabled, root: classes.root }}>
                        Login
                    </Button>
                    {loading && <CircularProgress size={24} className={classes.buttonProgress} />}
                </div>
                <div className={classes.loginForm}>
                    <Button style={{ width: '100%', height: 60 }} variant="contained" color="primary" onClick={forgotPasswordPressed}>
                        Forgotten Password
                    </Button>
                </div>
            </form>
        </div>
    );
}

export default LoginPage;